import React from 'react';

import * as Styled from './faq-card.styled';

type OwnProps = {
	title: string;
	description: string;
};

const FaqCard: React.FC<OwnProps> = ({ title, description }) => {
	return (
		<Styled.Wrapper>
			<Styled.Title>{title}</Styled.Title>
			<Styled.Divider />
			<Styled.Description>{description}</Styled.Description>
		</Styled.Wrapper>
	);
};

export default FaqCard;
